import { render, staticRenderFns } from "./AvoidExpertForm.vue?vue&type=template&id=cd5610a6&scoped=true"
import script from "./AvoidExpertForm.vue?vue&type=script&lang=js"
export * from "./AvoidExpertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5610a6",
  null
  
)

export default component.exports